import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AppShell } from '@/components/layout';

export const Route = createFileRoute('/(app)')({
  beforeLoad: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
